// extracted by mini-css-extract-plugin
export default {"heroSection":"Hero_heroSection__1XBte","heroGif":"Hero_heroGif__v1nwF","heroEarth":"Hero_heroEarth__B+eB6","heroBg":"Hero_heroBg__RFJus"};